/* eslint-disable react/prop-types */
import React from 'react';
import { useSpring, animated, config } from 'react-spring';

/** Rolls the displayed number to `value` whenever it changes. countUpOnMount rolls from 0
 * on first render (used in the sidebar); default only animates on later value changes.
 * `format` optionally formats each interpolated value (e.g. compact abbreviation); defaults to
 * a comma-grouped integer. */
const AnimatedNumber = ({ value, countUpOnMount = false, format }) => {
  const numericValue = Number(value) || 0;
  const { val } = useSpring({
    val: numericValue,
    from: { val: countUpOnMount ? 0 : numericValue },
    config: config.slow,
  });
  return (
    <animated.span style={{ fontFamily: 'inherit' }}>
      {val.interpolate((v) => (
        format ? format(Math.round(v)) : Math.round(v).toLocaleString('en-US')
      ))}
    </animated.span>
  );
};

export default AnimatedNumber;
